(() => {
  'use strict';
  if (customElements.get('arcos-autumn')) return;
  customElements.define('arcos-autumn', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.groups = [...this.querySelectorAll('[data-group]')];
      this.buttons = [...this.querySelectorAll('[data-filter]')];
      this.nav = this.querySelector('.ao-nav');
      this.woodTitle = this.querySelector('[data-group="wood"] h2');
      this.originalTitle = this.woodTitle?.innerHTML || '';
      this.buttons.forEach(button => {
        const value = button.dataset.filter;
        button.hidden = value !== 'all' && !this.groups.some(group => group.dataset.group === (value === 'sets' ? 'wood' : value));
        button.addEventListener('click', () => this.filter(value, true), options);
      });
      this.querySelector('.ao-reset')?.addEventListener('click', event => {
        event.preventDefault(); this.filter('all', true);
      }, options);
      this.querySelector('.ao-text-link')?.addEventListener('click', event => {
        event.preventDefault(); this.scrollToOffers();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        if (this.groups.some(group => group.dataset.blockId === event.detail?.blockId)) this.filter('all');
      }, options);
      this.header = document.querySelector('.header-section');
      this.measure = () => {
        const style = this.header && getComputedStyle(this.header);
        const sticky = style && ['sticky', 'fixed'].includes(style.position);
        this.style.setProperty('--ao-header-offset', `${sticky ? this.header.getBoundingClientRect().height : 0}px`);
        this.style.setProperty('--ao-nav-height', `${this.nav?.getBoundingClientRect().height || 0}px`);
      };
      this.observer?.disconnect();
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.measure);
        if (this.header) this.observer.observe(this.header);
        if (this.nav) this.observer.observe(this.nav);
      }
      window.addEventListener('resize', this.measure, options);
      this.filter('all'); this.measure();
    }
    filter(value, scroll = false) {
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === value)));
      this.groups.forEach(group => {
        group.hidden = !(value === 'all' || group.dataset.group === value || (value === 'sets' && group.dataset.group === 'wood'));
      });
      this.classList.toggle('only-sets', value === 'sets');
      if (this.woodTitle) {
        if (value === 'sets') this.woodTitle.textContent = this.dataset.setsTitle;
        else this.woodTitle.innerHTML = this.originalTitle;
      }
      const count = this.groups.filter(group => !group.hidden).reduce((sum, group) => sum + (value === 'sets' ? 2 : Number(group.dataset.offerCount)), 0);
      const label = this.buttons.find(button => button.dataset.filter === value)?.textContent.trim();
      this.querySelector('.ao-results').textContent = `${count} ${count === 1 ? this.dataset.wordOne : this.dataset.wordMany}${label ? ` · ${label}` : ''}`;
      if (this.nav) this.nav.hidden = this.groups.length === 0;
      if (scroll) this.scrollToOffers();
    }
    scrollToOffers() {
      this.measure?.();
      requestAnimationFrame(() => this.querySelector('.ao-offers').scrollIntoView({
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'
      }));
    }
    disconnectedCallback() {
      this.controller?.abort(); this.observer?.disconnect();
    }
  });
})();